import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=72c2e7dd&scoped=true&"
import script from "./UserUpdate.vue?vue&type=script&lang=js&"
export * from "./UserUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UserUpdate.vue?vue&type=style&index=0&id=72c2e7dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2e7dd",
  null
  
)

export default component.exports